import { atom } from 'jotai';

/**
 * Hash from a password-reset email link, set by `useResetPasswordLinkHandler`
 * before it opens the stage on `auth.reset-password`. The reset-password scene
 * reads this to render its form; cleared when the scene closes or navigates
 * away so a stale hash can't resurface on a later open.
 */
export const resetPasswordHashAtom = atom<string | null>(null);

/**
 * Error surfaced on the `auth.forgot-password` scene when the user arrived
 * via an expired/invalid reset link. Set by `useResetPasswordLinkHandler`
 * alongside opening the forgot-password scene; cleared when the user leaves.
 */
export const resetPasswordErrorAtom = atom<string | null>(null);
